<template>
  <figure :name="letter.name" class="letter" :style="styleObject"
       v-if="letter.decoration && Number(letter.decoration.is_back) === Number(reverse) && !letter.decoration.is_constant">
    <logo class="picture" v-if="isLogo" :decoration="letter.decoration" :picture="letter.font"></logo>
    <template v-if="!isLogo">
      <decoration class="picture" :decoration="letter.decoration">{{letter.word}}</decoration>
      <outline class="picture" v-if="letter.decoration.outline_color_id != null"
               :decoration="letter.decoration">
        {{letter.word}}
      </outline>
    </template>
  </figure>
</template>

<script>
  import Decoration from './Decoration.vue'
  import Outline from './Outline.vue'
  import Logo from './Logo.vue'

  export default {
    name: 'letter',
    components: {
      Decoration, Outline, Logo
    },
    props: ['letter', 'reverse'],
    computed: {
      isLogo() {
        return !!(this.letter.font && this.letter.font.image);
      },
      styleObject(){
        if (!this.letter.font){
          return;
        }
        if ('name' in this.letter.font){
          return {
            fontFamily: this.font_label(this.letter.font.name),
          };
        }

      }
    },
    created () {
      // console.log(this.letter.decoration);
    },
    methods: {
      font_label(name){
        // font-familyで.を使えないようなのでドットを消す
        return name.replace('.', '');
      }
    }
  }
</script>
<style scoped>
  .letter{
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>
